import type zh from '../zh/shell';

/** App shell, English. Typed against the zh file so a missing key fails tsc. */
const shell: typeof zh = {
  notFound: 'Page not found',
  nav: {
    label: 'Main navigation',
    workspace: 'Workspace',
    skills: 'Skill Hub',
    tasks: 'Tasks',
    eval: 'Eval',
    feedback: 'Feedback',
    comingSoon: '{{label}} (coming soon)',
    closeMenu: 'Close navigation menu',
    openMenu: 'Open navigation menu',
    home: 'Rocky home',
    logoAlt: 'Rocky',
  },
  user: {
    viewingAs: 'Viewing as: {{alias}}',
    fallbackName: 'User',
  },
  popover: {
    close: 'Close',
    accountSettings: 'Account & Settings',
    backendManagement: 'Backend Management System',
    switchAgent: 'Switch Agent',
    language: 'Language',
    viewAsOther: 'View as Another User',
    aliasPlaceholder: 'Enter alias...',
    go: 'Go',
    aliasInvalid: 'A login is letters, digits, dots, dashes or underscores — no spaces or @.',
    exitViewing: 'Exit viewing mode',
  },
  mobileTopBar: {
    files: 'Files',
    openChat: 'Open chat',
  },
  impersonation: {
    banner: 'Admin Viewing Mode: <strong>{{alias}}</strong>',
    exitLabel: 'Exit impersonation mode',
    exit: 'Exit',
  },
  accessGate: {
    noAccess: 'The account <strong>{{uid}}</strong> does not have Rocky access yet',
    intro:
      '<strong>Rocky is the CMHK personal assistant.</strong> There is nothing to install: <strong>it works out of the box,</strong> with all data and skills preconfigured, focused on news and analysis tailored to you and your team. (<site>https://rocky.ai.aws.dev/</site>)',
    sources: 'Connected data and external news:',
    wechat: 'WeChat Official Accounts',
    custom: 'You can also contact us to build reports and news channels for your team and distribute them.',
    trial:
      '<strong>You are welcome to try it.</strong> Add your login in <quip>Quip</quip> and Rocky will contact you within 1 business day. You can also reach us directly (<strong>@tiancho</strong>, <strong>@qiuyac</strong>).',
    slides: {
      workspace: { caption: 'Rocky workspace', alt: 'Rocky Portal workspace' },
      weekly: { caption: 'Weekly Usage & Revenue Report', alt: 'Example Weekly Usage & Revenue Report' },
      forecast: { caption: 'Baseline Forecast Report', alt: 'Example Baseline Forecast Report' },
    },
    footer: 'CMHK Agent Platform · Built for your team',
  },
};

export default shell;
